import React from 'react'
function bytesFormatter(bytes, decimals) {

  if(!bytes) {
    return ''
  }

  if(bytes === 0) return '0 Bytes'

  var k = 1024,
    dm = decimals <= 0 ? 0 : decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

function sizeFormatter(cell, row) {
  const KB = 1024
  const MB = 1024 * 1000
  const GB = 1024 * 1000 * 1000
  if (cell > GB) {
    return (<span>{ (cell/GB).toFixed(2) } Gb</span>)
  } else if (cell > MB) {
    return (<span>{ (cell/MB).toFixed(2) } Mb</span>)
  } else if (cell > KB) {
    return (<span>{ (cell/KB).toFixed(2) } Kb</span>)
  } else {
    return (<span>{ cell }</span>)
  }
}
var processStatusConstants = {
  UPLOAD_SUCCESS:'UploadS',
  UPLOAD_FAILED : 'UploadF',
  SCAN_SUCCESS : 'clean',
  SCAN_FAILED : 'infected',
  SCAN_SKIPPED : 'no',
}


function shouldFileDisable(file){
  let processStatus = file.processStatus
  if (!processStatusConstants) processStatusConstants = 'catalog clean'
  if (!processStatus) {
    // If the file is not in the database but says it's pathOnDisk is __s3__ then
    //  this file has mostly likely been migrated and stuck in scanning so UploadS
    if (file.pathOnDisk == '__s3__'){
      processStatus = 'UploadS'
    } else {
      processStatus = 'stored'
    }
  }

  const disableList = [processStatusConstants.UPLOAD_SUCCESS,
    processStatusConstants.UPLOAD_FAILED,
    processStatusConstants.SCAN_FAILED
  ]
  const m  = disableList.includes(processStatus)
  return m
}

export {
  bytesFormatter,
  sizeFormatter,
  shouldFileDisable,
  processStatusConstants
}


